import React from 'react';
import { connectDeep } from 'redux-utils';
import uuid from 'uuid/v4';
import styled from 'styled-components';

import { savePermissions } from 'actions/gallery';
import {
  connect as connectPermissions
} from '../../Permission/index';
import { ModalProps } from '../types';
import Modal from '../../Modal/index';

import i18n from 'i18n';
import PermissionsEditor from '../../Permission/PermissionsEditor';
import { GalleryAppPermissions } from '../../Permission/types';
import { fitbitGray } from '../../../../themes';

const AboveSection = styled.div`
  margin-top: 20px;
  color: ${fitbitGray};
`;

const mapDispatchToProps = (dispatch: any, { app }: any) => ({
  savePermissions: (grantedPermissions: any) =>
    dispatch(savePermissions({ appId: app.id, grantedPermissions }))
});

type ReduxProps = ReturnType<typeof mapDispatchToProps>;

interface ConnectedPermissionsProps {
  permissions: GalleryAppPermissions;
}

interface PermissionModalProps extends ModalProps, ConnectedPermissionsProps, ReduxProps {}

class PermissionModal extends React.Component<PermissionModalProps> {
  componentDidMount() {
    const {
      permissions,
      savePermissions,
    } = this.props;

    savePermissions(permissions);
  }

  render() {
    const {
      app,
      onSuccess,
      onCancel,
      savePermissions,
    } = this.props;
  
    const onPermissionsChange =
      async (grantedPermissions: any) => savePermissions(grantedPermissions);

    return (
      <Modal
        id={`PermissionModal-${uuid()}`}
        contentAbove={
          <AboveSection>
            <div>{i18n('component.PermissionModal.text')()}</div>
          </AboveSection>
        }
        contentCenter={
          <PermissionsEditor app={app} onChange={onPermissionsChange} />
        }
        title={i18n('component.PermissionModal.title')({ appName: app.name })}
        onClose={onCancel}
        buttons={[
          {
            text: i18n('component.PermissionModal.disallowButtonText')(),
            onClick: onCancel,
            id: 'permissions-button-cancel',
          },
          {
            text: i18n('component.PermissionModal.allowButtonText')(),
            onClick: onSuccess,
            highlight: true,
            id: 'permissions-button-ok',
          }
        ]}
      />
    );
  }
}

export default connectPermissions(
  connectDeep(null, mapDispatchToProps)(PermissionModal)
);
